<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>Malcolm Tilsed’s book, <em>Bizarre Poetic World of Malcolm Tilsed,</em> is dedicated to the readers, may you find health love and happiness in your life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?73b3a402